import { render, staticRenderFns } from "./IntegrationItem.vue?vue&type=template&id=01053ee5&scoped=true&"
import script from "./IntegrationItem.vue?vue&type=script&lang=js&"
export * from "./IntegrationItem.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationItem.vue?vue&type=style&index=0&id=01053ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01053ee5",
  null
  
)

export default component.exports